/* WERALIS — шапка и подвал, редакция 2026-09-18.
   Сайтовый скрипт: шапка и подвал стоят на каждой странице.

   Мега-меню на десктопе раскрывает ТОЛЬКО пункт Shop (слово IB 18.09): прежнее
   правило .hasmega:hover роняло панель при наведении на любое место шапки, включая
   лого и корзину. Класс .megaopen вешает скрипт — по наведению и фокусу на .shopbtn,
   снимает по уходу курсора со строки, по Esc и по уходу фокуса. На узком экране
   наведения нет — там то же меню открывает бургер классом .mopen.

   Кнопка «наверх» получила обработчик здесь: в макете её стиль .totop.on есть,
   а кода, который вешает .on, не было — кнопка не появлялась никогда. */
(function () {
  'use strict';

  function chrome() {
    var row = document.querySelector('.wv2 .hasmega');
    var burger = document.querySelector('.wv2 .burger');
    if (row && burger) {
      burger.addEventListener('click', function () {
        var open = row.classList.toggle('mopen');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      /* Esc закрывает меню: открытая панель на весь экран без выхода с
         клавиатуры — ловушка для того, кто не пользуется мышью. */
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !row.classList.contains('mopen')) return;
        row.classList.remove('mopen');
        burger.setAttribute('aria-expanded', 'false');
        burger.focus();
      });
    }

    /* Панель Shop. Закрытие по уходу курсора слушает СТРОКУ, а не кнопку: панель
       лежит под строкой, и уход с кнопки вниз, в панель, закрывать её не должен. */
    var shop = document.querySelector('.wv2 .shopbtn');
    if (row && shop) {
      var open = function () { row.classList.add('megaopen'); shop.setAttribute('aria-expanded', 'true'); };
      var shut = function () { row.classList.remove('megaopen'); shop.setAttribute('aria-expanded', 'false'); };
      /* Закрытие по уходу с Shop или панели (слово IB 19.09): прежде панель держалась,
         пока курсор был где угодно в строке — на лого, About, иконках. 140 мс — запас
         на путь от кнопки вниз до панели через пустую часть строки. */
      var mega = row.querySelector('.mega'), t;
      var inZone = function (el) { return shop.contains(el) || (mega && mega.contains(el)); };
      shop.addEventListener('mouseenter', function () { clearTimeout(t); open(); });
      shop.addEventListener('focus', open);
      row.addEventListener('mouseover', function (e) {
        if (!row.classList.contains('megaopen')) return;
        clearTimeout(t);
        if (!inZone(e.target)) t = setTimeout(shut, 140);
      });
      row.addEventListener('mouseleave', function () { clearTimeout(t); shut(); });
      /* Тач-устройство события наведения не шлёт: там панель переключается нажатием. */
      shop.addEventListener('click', function (e) {
        e.preventDefault();
        if (row.classList.contains('megaopen')) { shut(); } else { open(); }
      });
      shop.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        if (row.classList.contains('megaopen')) { shut(); } else { open(); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !row.classList.contains('megaopen')) return;
        shut();
        shop.focus();
      });
      document.addEventListener('focusin', function (e) {
        if (!row.classList.contains('megaopen')) return;
        if (shop.contains(e.target)) return;
        var mega = row.querySelector('.mega');
        if (mega && mega.contains(e.target)) return;
        shut();
      });
    }

    var top = document.querySelector('.wv2 .totop');
    if (top) {
      top.addEventListener('click', function () {
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      });
      var ticking = false;
      function sync() {
        ticking = false;
        top.classList.toggle('on', window.scrollY > window.innerHeight);
      }
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(sync);
      }, { passive: true });
      sync();
    }

    /* Шапка как у Amazon (IB 26.10): прокрутка вниз — шапка уходит, вверх — возвращается.
       Стиль .hdr-off — weralis-refresh.css. Не прячется у верха страницы, при открытом меню
       и когда фокус клавиатуры внутри шапки. Порог 6 px — дрожание пальца не дёргает шапку. */
    var bar = document.querySelector('.wv2 .hdr');
    var wrap = bar && bar.parentElement;
    if (wrap) {
      var lastY = window.scrollY, busy = false;
      function hdr() {
        busy = false;
        var y = window.scrollY, d = y - lastY;
        var keep = y < wrap.offsetHeight || wrap.contains(document.activeElement) ||
                   (row && (row.classList.contains('mopen') || row.classList.contains('megaopen')));
        if (keep || d < -6) wrap.classList.remove('hdr-off');
        else if (d > 6) wrap.classList.add('hdr-off');
        if (keep || Math.abs(d) > 6) lastY = y;
      }
      window.addEventListener('scroll', function () {
        if (busy) return;
        busy = true;
        requestAnimationFrame(hdr);
      }, { passive: true });
      wrap.addEventListener('focusin', function () { wrap.classList.remove('hdr-off'); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', chrome);
  } else {
    chrome();
  }
})();
